<template>
  <div :class="classes()">
    <Row verticalCenter>
      <Col :xs="12" :l="6" :class="`${el}__benefitItemImage`">
        <div :class="`${el}__benefitItemImageInner`">
          <Illustration
            :brush="parseInt(image.replace('teaser-', ''))"
            :name="image"
            :illuScale="1.8"
            responsive
          />
        </div>
      </Col>
      <Col :xs="12" :l="6" :class="`${el}__benefitItemText`">
        <div :class="`${el}__benefitItemTextInner`">
          <Headline :staticClass="`${el}__benefitsItemHeadline`" size="s" :heading="3" responsive>
            {{ headline }}
          </Headline>
          <Copy element="div" responsive :staticClass="`${el}__benefitsItemCopy`">
            {{ copy }}
          </Copy>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Headline from '@/objects/Headline';
import Illustration from '@/objects/Illustration';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

export default {
  name: 'Benefits',
  props: {
    headline: String,
    copy: String,
    image: String,
    direction: String,
  },
  components: {
    Copy,
    Headline,
    Illustration,
    Row,
    Col,
  },
  data() {
    return {
      el: 'v-home',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}__benefitItem`]: true,
          [`${el}__benefitItem--${this.direction}`]: this.direction,
        };
      },
    };
  },
};
</script>
